import { Component, OnInit } from '@angular/core';
import { WizardStep } from 'src/app/wizard/wizard.component';
import { PatientView } from 'src/app/model/patient';
import { MedicalServiceWizardService } from 'src/app/services/wizard/medical-service/medical-service-wizard';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { StudyReportDeliveryWizard } from '../../../../../services/wizard/logistic/study-report-delivery-wizard.service';

@Component({
  selector: 'app-study-report-delivery-patient',
  templateUrl: './study-report-delivery-patient.component.html',
  styleUrls: ['./study-report-delivery-patient.component.css']
})

export class StudyReportDeliveryPatientComponent implements OnInit, WizardStep {

  loading: boolean;
  completed: boolean;
  isInit: boolean;
  patient: PatientView;

  constructor(private studyReportDeliveryWizard: StudyReportDeliveryWizard) {
  }

  activate(): void {
    this.patient = this.studyReportDeliveryWizard.getPatiet();
  }

  save(): void {
  }

  get valid(): boolean {
    return this.completed;
  }


  async ngOnInit() {
    this.isInit = true;
  }
}
